<template>
  <div id="productDetail">
    <div class="filter-container flex_bet">
      <div class="order_info">
        订单号：{{orderInfo.productId}}， 状态：{{orderInfo.statusZh}}，
        机型：{{orderInfo.productModel}}，
        归属公司：{{orderInfo.companyName}}，数量：{{tableList.length}} </br>
        备注：{{orderInfo.remark}}
      </div>
      <div>
        <el-button :title="isBatch? '退出管理': '批量管理'" type="primary"
          @click="batch">{{ isBatch? '退出管理': '批量管理' }}</el-button>
        <el-button icon="el-icon-download" type="primary" @click="downExcel" />
      </div>
    </div>
    <el-table v-loading.body="listLoading" :data="tableList" element-loading-text="Loading" border fit
      highlight-current-row>
      <el-table-column v-if="isBatch" align="center">
        <template slot="header" slot-scope="scope">
          <span class="all_select_checkbox click boxBack" @click="allSelect">
            {{ isAllSelect? '全选':'全不选' }}
          </span>
        </template>
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.isSelected" @change="selectionChange(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column :label="$t('adminView.NO')" align="center" prop="idx" width="60" />
      <el-table-column :label="'MCUID'" align="center" prop="yhubMcu" />
      <el-table-column :label="'SN'" align="center" prop="yhubSn" width="120" />
      <el-table-column label="PC" align="center" prop="yhubPc" />
      <!-- <el-table-column :label="$t('adminView.series')" align="center" prop="yhubMl" /> -->
      <el-table-column :label="$t('QR.Dateofmanufacture')" align="center" prop="yhubMd" />
      <el-table-column label="硬件型号" align="center" prop="hardware" />
      <el-table-column label="ICCID" align="center" prop="simId" />
      <el-table-column label="IMEI" align="center" prop="netModuleImei" />
      <!-- <el-table-column label="InputRange" align="center" prop="inputRange" /> -->
      <!-- <el-table-column label="Label" align="center" prop="labelRemark" /> -->

      <el-table-column :label="$t('adminView.CurrentVersion')" align="center" prop="fwVersion" />
      <el-table-column v-if="isUpdate" label="状态" align="center" prop="">
        <template slot-scope="scope">
          <div v-if="scope.row.isUpdate" style="margin-left:5px;">
            ({{ scope.row.isUpdateCompleted ? '更新完成' : '更新中' }}
            <i v-if="!scope.row.isUpdateCompleted" class="el-icon-loading" />
            {{ scope.row.progress }}%)
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" :label="$t('yhubReport.Operating')" width="200">
        <template slot-scope="scope">
          <!-- <el-button style="margin-bottom: 10px;" type="primary" size="mini" icon="el-icon-view" title="生命周期"
            @click="openView(scope.row)" /> -->
          <!-- <el-button style="margin-bottom: 10px;" icon="el-icon-data-line" size="mini" type="primary" title="数据详情"
            @click="goToReport(scope.row)" /> -->
          <el-button style="margin-bottom: 10px;" v-if="$store.state.isAdmin" icon="el-icon-back" size="mini"
            type="primary" title="转移设备" @click="moveOne(scope.row)" />
          <!-- <el-button style="margin-bottom: 10px;" v-if="$store.state.isAdmin" icon="el-icon-delete" size="mini"
            type="primary" title="删除设备" @click="deleteOne(scope.row)" /> -->
          <el-button style="margin-bottom: 10px;" icon="el-icon-tickets" size="mini" type="primary" title="测试记录"
            @click="goToTestRecord(scope.row)" />
          <el-button style="margin-bottom: 10px;" icon="el-icon-mobile-phone" size="mini" type="primary" title="app测试记录"
            @click="goToAppTestRecord(scope.row)" />
        </template>
      </el-table-column>
    </el-table>
    <!-- 底部批量更新按钮 -->
    <div v-if="isBatch" class="btn_list textR" style="margin-top: 13px;">
      <el-button v-preventReClick type="primary" :disabled="temporaryList.length == 0" @click="updateConfig">更新配置</el-button>
      <el-button type="primary" :disabled="temporaryList.length == 0" @click="openFW">更新版本</el-button>
      <el-button type="primary" :disabled="temporaryList.length == 0" @click="visible3 = true">归属公司</el-button>
      <el-button type="primary" :disabled="temporaryList.length == 0" @click="exportYhubs">导出设备</el-button>

    </div>
    <!-- 生产步骤弹窗 -->
    <el-dialog :close-on-click-modal="false" class="statusPop" width="70%" :visible.sync="isShowPop">
      <p>{{ $t('BondOrUpdateDevice.SN') }}:{{ currentObj.yhubSn }} </p>
      <p class="blockTitleP" style="margin:10px 0 0 -10px;border-top: 1px solid #dcdfe6;">{{ $t('sim.lifeCycle') }}</p>
      <div class="baseContentWarp" style="padding-left: 10px;">
        <p v-if="stepList.length==0" style="text-align: center;">{{ $t('yhubReport.Nodata') }}</p>
        <el-steps direction="vertical" :active="stepList.length" :space="70" finish-status="process">
          <el-step v-for="(item,index) in stepList" :key="index" :title="item.title" :description="item.description">
            <template slot="description">
              <!-- <div class="step-row" v-for="(stepDetail,sindex) in item.stepDetailArr" :key='sindex'> -->
              <div class="step-row">
                <p>{{ item.stepDetail.updateInfo }}</p>
                <p>内容：{{ item.stepDetail.content }}</p>
                <div v-if="item.stepDetail.detailInfo">
                  <p>详情：
                  <pre>{{ item.stepDetail.detailInfo }}</pre>
                  </p>
                </div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
    </el-dialog>
    <!-- 订单转移弹窗 -->
    <el-dialog :close-on-click-modal="false" class="statusPop" width="80%" :visible.sync="showMovePop">
      <el-form ref="dataForm" :model="moveObj" label-position="right" label-width="180px">
        <div class="box">
          <el-form-item label="当前订单号">
            <el-input v-model="moveObj.curProductId" :disabled="true" @input="change($event)" />
          </el-form-item>
          <el-form-item label="网卡型号">
            <el-input v-model="moveObj.curNetModule" :disabled="true" @input="change($event)" />
          </el-form-item>
          <el-form-item label="apn">
            <el-input v-model="moveObj.curApn" :disabled="true" @input="change($event)" />
          </el-form-item>
        </div>
        <div class="box">
          <el-form-item label="转移订单号">
            <el-input v-model="moveObj.newProductId" @input="change($event)" @blur="blurProId(moveObj.newProductId)" />
          </el-form-item>
          <el-form-item label="网卡型号">
            <el-input v-model="moveObj.newNetModule" :disabled="true" @input="change($event)" />
          </el-form-item>
          <el-form-item label="apn">
            <el-input v-model="moveObj.newApn" :disabled="true" @input="change($event)" />
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
        <el-button @click="showMovePop=false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" :disabled="disabledSubmit" type="primary"
          @click="moveConfirmPop">{{ $t('button.Confirm') }}</el-button>
      </div>
    </el-dialog>
    <!-- 更新版本弹窗 -->
    <el-dialog :close-on-click-modal="false" class="statusPop" width="80%" :visible.sync="showUpdateVerPop">
      <div v-loading="updateVerLoad">
        <el-radio v-model="updateType" :label="1" @change="change">网络更新</el-radio>
        <el-radio v-model="updateType" :label="2" @change="change">蓝牙更新</el-radio>
        <el-table :data="fwList" border fit highlight-current-row style="margin-top:10px;">
          <el-table-column label="硬件型号" prop="deviceModel" align="center" />
          <el-table-column label="文件名称" prop="deviceName" align="center" />
          <el-table-column label="系统版本" prop="deviceVersion" align="center">
            <template slot-scope="scope">
              V{{ scope.row.deviceVersion }}
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remark" align="center" />
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="selectFW(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
          <div class="pagination-container">
            <el-pagination v-if="pageshow" background current-page.sync="listQuery.pageInfo.page"
              :page-sizes="listQuery.pageInfo.pageList" :page-size="listQuery.pageInfo.limit"
              layout="total, sizes, prev, pager, next, jumper" :total="listQuery.pageInfo.total"
              @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 测试日志弹窗 -->
    <el-dialog :close-on-click-modal="false" class="testRecordPop" width="80%" :visible.sync="showTestRecordPop"
      @close="closeTestRecordPop">
      <div v-loading="testRecordLoad">
        <div class="filter-container searchBoxWarp" style="margin-bottom: -10px;">
          <el-select v-model="testRecordObj.result" placeholder="测试结果" class="el-input-group searchItem" clearable
            filterable @change="changeSearch">
            <el-option key="1" label="通过" value="1" />
            <el-option key="0" label="不通过" value="0" />
          </el-select>
          <el-select v-model="testRecordObj.stage" placeholder="阶段" class="el-input-group searchItem" clearable
            filterable @change="changeSearch">
            <el-option key="1" label="半成品" value="semiPro" />
            <el-option key="2" label="成品" value="Pro" />
            <el-option key="3" label="老化" value="aging" />
          </el-select>
        </div>
        <el-table :data="testRecordList" border fit highlight-current-row style="margin-top:10px;"
          class="testRecordTable">
          <el-table-column label="创建时间" prop="createTimeZh" align="center" min-width="12%" />
          <el-table-column label="创建人" prop="createBy" align="center" min-width="12%" />
          <el-table-column label="测试结果" prop="" align="center" min-width="12%">
            <template slot-scope="scope">
              {{ scope.row.result==1?'通过':'不通过' }}
            </template>
          </el-table-column>
          <el-table-column label="阶段" prop="" align="center" min-width="12%">
            <template slot-scope="scope">
              <span v-if="scope.row.stage=='semiPro'">半成品</span>
              <span v-if="scope.row.stage=='pro'">成品</span>
              <span v-if="scope.row.stage=='aging'">老化</span>
            </template>
          </el-table-column>
          <el-table-column label="数据" align="center" prop="data" min-width="52%" />
        </el-table>
      </div>
    </el-dialog>
    <yhubTrendTem :show-yhub-trend-pop="showYhubTrendPop" :basicinfo="basicinfo" @closeTrendPop="closeTrendPop" />

    <el-dialog width="80%" :title="'测试记录：'+ currentSn" :visible.sync="innerVisible">
      <el-table :data="testLogs" border fit highlight-current-row>
        <el-table-column label="步骤" align="center" prop="step" width="50" />
        <el-table-column label="项目名称" align="center" prop="name" width="250" />
        <el-table-column label="数据" align="center" prop="stepData">
          <template slot-scope="scope">
            <div v-html="scope.row.extend"></div>
          </template>
        </el-table-column>
        <el-table-column label="来源" align="center" prop="source" width="50" />
        <el-table-column label="时间" align="center" prop="createTime" width="160">
          <template slot-scope="scope">
            <span>{{scope.row.createTime | timeFormat}}</span>
          </template>
        </el-table-column>
        <el-table-column label="测试人" align="center" prop="createBy" width="60" />

      </el-table>
    </el-dialog>

    <el-dialog width="40%" :title="'归属公司设置'" :visible.sync="visible3">
      <p class="item_p">选择目标归属公司</p>
      <el-select v-model="tarCompanyId" filterable placeholder="请选择" clearable @change="companyChange">
        <el-option v-for="item in companyOption" :key="item.companyId" :label="item.companyName"
          :value="item.companyId">
        </el-option>
      </el-select>
      <!-- {{tarCompanyName}} -->
      <p class="item_p">是否重置设备</p>
      <el-switch v-model="resetDevice" active-color="#ff4949">
      </el-switch>
      <span>{{resetDevice? '重置':'不重置'}}</span>
      <p class="item_p"></p>
      <el-button type="primary" @click="submitOwner">提交</el-button>
    </el-dialog>
  </div>
</template>

<script>
import {
  listBaseYhubInfoByProductId, getProductLog, getProductConfigSimple,
  transferProduct, deleteProductByYhubSn, batchUpdate, getFwUpdateProgress,
  updateDeviceConfig, updateDeviceWarningSetting, findManufactureTestLog, batchChangeCompany,
  exportYhubBaseData
} from '@/api/product'
import { pageDeviceSystemVersionList } from '@/api/firmwareUpdate'
import { add } from '@/api/blueTooth'
import i18n from '@/i18n'
import { getDateAndHour } from '@/utils/updateTime.js'
import yhubTrendTem from '@/views/product/yhubTrendTem'
import { pagination } from '@/utils/init_table' // 分页
import { mapState } from 'vuex'
export default {
  components: {
    yhubTrendTem
  },
  data () {
    return {
      visible3: false,
      tableList: null,
      listLoading: true,
      currentObj: {},
      isShowPop: false,
      stepList: [],
      basicinfo: {},
      showYhubTrendPop: false,
      showMovePop: false,
      moveObj: {
        curProductId: null,
        curNetModule: null,
        curApn: null,
        newProductId: null,
        newNetModule: null,
        newApn: null,
        yhubSn: null
      },
      disabledSubmit: true,
      isBatch: false,
      isAllSelect: false,
      temporaryList: [], // 选中的list
      showUpdateVerPop: false,
      updateVerLoad: true,
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      fwList: [],
      currentModel: null, // 硬件型号
      checkProgresTimer: null,
      isUpdate: false,
      updateType: 1,
      showTestRecordPop: false,
      testRecordLoad: true,
      mcuId: null,
      testRecordObj: {
        result: null,
        stage: null
      },
      testRecordList: [],
      currentSn: '',
      testLogs: [],
      innerVisible: false,
      tarCompanyId: 4,
      tarCompanyName: '',
      resetDevice: false,
      orderInfo: {}
    }
  },
  computed: {
    ...mapState(['companyOption'])
  },
  created () {
    this.queryList()
    clearInterval(this.checkProgresTimer)
    this.checkProgresTimer = null
  },
  mounted () {
    setTimeout(() => {
      this.checkListProgress()
    }, 3000)
    const pStr = sessionStorage.getItem('admin_product_item')
    if (pStr != 'null') {
      this.orderInfo = JSON.parse(pStr)
      console.log(this.orderInfo)
    }
  },
  beforeDestroy () {
    clearInterval(this.checkProgresTimer)
    this.checkProgresTimer = null
  },
  methods: {
    exportYhubs () {
      const snArray = []
      this.temporaryList.forEach(item => {
        snArray.push(item.yhubSn)
      })
      const sns = snArray.join(',')
      const url = process.env.VUE_APP_BASE_API + '/v3/manager/device/exportYhubBaseData?sns=' + sns
      open(url)
      // exportYhubBaseData(sns).then(res =)
    },
    companyChange (val) {
      console.log(val)
      const obj = this.companyOption.find(item => item.companyId == val)
      if (obj) this.tarCompanyName = obj.companyName
    },
    submitOwner () {
      if (this.tarCompanyId) {
        this.visible3 = false
        const mcuIds = []
        this.temporaryList.forEach(item => {
          mcuIds.push(item.yhubMcu)
        })
        console.log(mcuIds)
        batchChangeCompany({
          "mcuIdList": mcuIds,
          "reset": this.resetDevice,
          "tarCompanyId": this.tarCompanyId,
          "tarCompanyName": this.tarCompanyName
        }).then(res => {
          console.log('修改归属公司结果', res)
          if (res.resultCode == 1001) {
            this.$message({
              type: 'success',
              message: '修改归属公司成功：' + res.resultModel.succList.length + '，失败：' + res.resultModel.failList.length
            })
          }
        })
      }
    },
    closeTrendPop () {
      this.showYhubTrendPop = false
    },
    queryList () {
      // alert(this.dialogObj.productId)
      this.listLoading = true
      listBaseYhubInfoByProductId(this.$route.query.productId).then(response => {
        console.log('已生产的设备列表：', response)
        this.listLoading = false
        var data = response.resultModel || []
        data.forEach((v, index) => {
          v.idx = index + 1
          v.isSelected = false
          v.isUpdate = false
          v.inputRange = this.$route.query.inputRange
          v.labelRemark = this.$route.query.labelRemark
          v.productId = this.$route.query.productId
          if (v.simId) {
            v.simId = v.simId.replace('F', '')
            v.simSSN = v.simId.substring(6)
          }
        })
        this.tableList = data
        this.isUpdate = false
      })
    },
    openView (row) { // 查看生命周期
      this.isShowPop = true
      this.currentObj = row
      // row.yhubMcu = '001d800b554b431520393638' // 假数据
      getProductLog({ mcuId: row.yhubMcu }).then(res => {
        if (res.resultCode == 1001) {
          this.stepList = []
          var data = res.resultModel || []
          data.forEach(v => {
            var label = ''
            var stepData = JSON.parse(v.stepData) || {}
            var stepTime = stepData.time
            var content = ''
            var detailInfo = ''
            var source = v.source

            if (source == 2) {
              // Yhub测试上位机
              switch (v.step) {
                case 0: label = '转移订单'; content = '转移后的订单号：' + stepData.newProductConfigId + '  /  ' + ' 转移前的订单号：' + stepData.oldProductConfigId; break
                case -1: label = '删除设备'; content = stepData; break
                case 1: label = '设置、校准'; content = stepData.action; detailInfo = stepData.data; break
                case 2: label = 'RS485、McuId检测'; content = stepData.action; detailInfo = stepData.data; break
                case 3: {
                  label = '蓝牙、继电器检测'
                  content = stepData.action; detailInfo = stepData.data
                  break
                }
                case 4: label = '电流、电压检测'; content = stepData.action; detailInfo = stepData.data; break
                case 5: {
                  label = '温度、联网、版本检测'
                  content = stepData.action; detailInfo = stepData.data
                  break
                }
              }
            } else {
              // Yhub测试APP
              switch (v.step) {
                case 0: label = '转移订单'; content = '转移后的订单号：' + stepData.newProductConfigId + '  /  ' + ' 转移前的订单号：' + stepData.oldProductConfigId; break
                case -1: label = '删除设备'; content = stepData; break
                case 1: label = '绑定条形码'; content = stepData.action; detailInfo = v.barcode; break
                case 2: label = '推送配置'; content = stepData.action; detailInfo = stepData.data; break
                case 3: {
                  label = '校准数据'
                  content = stepData.action; detailInfo = stepData.data
                  break
                }
                case 4: label = '检查数据是否正常'; content = stepData.action; detailInfo = ''; break
                case 5: {
                  label = '检查模块是否正常'
                  content = stepData.action; detailInfo = stepData.data
                  break
                }
              }
            }

            var timeStr = '--'
            if (stepTime) {
              timeStr = getDateAndHour(stepTime, '')
            } else if (v.createTime) {
              timeStr = getDateAndHour(v.createTime, '')
            }

            this.stepList.push({
              title: '[ Step ' + v.step + ' ] : ' + label,
              description: v.createTime + '   ' + v.stepData + '   [ ' + i18n.t('QR.Uploader') + ': ' + v.createBy + ' ]',
              stepDetail: {
                // updateInfo: '更新时间：' + (v.createTime ? getDateAndHour(v.createTime, '') : '--') + ' 更新人：' + (v.createBy || '--'),
                updateInfo: '更新时间：' + timeStr + ' 更新人：' + (v.createBy || '--'),
                creatTimeZh: v.createTime ? getDateAndHour(v.createTime, 'noSecond') : '--',
                createBy: v.createBy || '--',
                content: content,
                detailInfo: detailInfo
              }
            })
          })
        }
      })
    },
    goToReport (row) { // 查看走势图
      this.showYhubTrendPop = true
      this.basicinfo = {
        openIgnitionVol: row.openIgnitionVol,
        workHourmeterVol: row.workHourmeterVol,
        deviceSn: row.yhubSn,
        mcuId: row.yhubMcu
        // mcuId: '05d7ff333332534e43204458'
      }
    },
    moveOne (row) { // 转移设备弹窗--打开
      this.showMovePop = true
      this.moveObj.curProductId = row.productId
      this.moveObj.yhubSn = row.yhubSn
      getProductConfigSimple({ productConfigId: row.productId }).then(res => {
        if (res.resultCode == 1001 && res.resultModel) {
          this.moveObj.curNetModule = res.resultModel.netModule
          this.moveObj.curApn = res.resultModel.apn
        }
      })
    },
    blurProId (val) { // 转移设备弹窗--转移订单号失焦
      getProductConfigSimple({ productConfigId: val }).then(res => {
        if (res.resultCode == 1001 && res.resultModel) {
          this.moveObj.newNetModule = res.resultModel.netModule
          this.moveObj.newApn = res.resultModel.apn
          this.moveObj.maxProduce = res.resultModel.maxProduce
          this.moveObj.nowProduce = res.resultModel.nowProduce
          this.disabledSubmit = false
        } else {
          this.disabledSubmit = true
          this.$message({
            type: 'error',
            message: '订单号不存在'
          })
        }
      })
    },
    moveConfirmPop () { // 转移设备弹窗--提交
      if (this.moveObj.curNetModule != this.moveObj.newNetModule || this.moveObj.curApn != this.moveObj.newApn) {
        this.$confirm('网卡型号或APN不相同，是否确定转移到此订单？', '', {//
          confirmButtonText: i18n.t('button.Confirm'), // '确定'
          cancelButtonText: i18n.t('button.Cancel'),
          type: 'warning'
        }).then(() => {
          this.moveSure()
        }).catch(() => { })
      } else {
        this.moveSure()
      }
    },
    moveSure () { // 确定转移
      var param = {
        'createBy': this.$store.state.userInfo.userLoginName,
        'newProductConfigId': this.moveObj.newProductId,
        'oldProductConfigId': this.moveObj.curProductId,
        'yhubSn': this.moveObj.yhubSn
      }
      if (this.moveObj.maxProduce <= this.moveObj.nowProduce) { // 最大生产个数<=已生产个数
        this.$confirm(this.moveObj.newProductId + '订单已达最大生产个数，是否确定转移到此订单？', '', {
          confirmButtonText: i18n.t('button.Confirm'), // '确定'
          cancelButtonText: i18n.t('button.Cancel'),
          type: 'warning'
        }).then(() => {
          transferProduct(param).then(res => {
            if (res.resultCode == 1001) {
              this.$message({
                type: 'success',
                message: i18n.t('warningSet.submitted')
              })
              this.showMovePop = false
              this.queryList()
            }
          })
        }).catch(() => {
        })
      } else {
        transferProduct(param).then(res => {
          if (res.resultCode == 1001) {
            this.$message({
              type: 'success',
              message: i18n.t('warningSet.submitted')
            })
            this.showMovePop = false
            this.queryList()
          }
        })
      }
    },
    deleteOne (row) { // 删除
      this.$confirm('确定删除该设备吗？', '', {//
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        var param = {
          'createBy': this.$store.state.userInfo.userLoginName,
          'oldProductConfigId': row.productId,
          'yhubSn': row.yhubSn
        }
        deleteProductByYhubSn(param).then(res => {
          if (res.resultCode == 1001) {
            this.$message({
              type: 'success',
              message: i18n.t('warningSet.submitted')
            })
            this.showMovePop = false
            this.queryList()
          }
        })
      }).catch(() => { })
    },
    change (e) {
      this.$forceUpdate()
    },
    batch () { // 批量处理--打开/关闭
      this.isBatch = !this.isBatch
      this.isAllSelect = !!this.isBatch
      this.tableList.forEach((v, index) => {
        v.isSelected = false
      })
    },
    allSelect (bol) { // 批量处理--全选/全不选
      this.isAllSelect = bol == 'cancelSelect' ? false : !this.isAllSelect
      this.tableList.forEach(v => {
        v.isSelected = bol == 'cancelSelect' ? false : !this.isAllSelect
        this.selectionChange(v)// 单选--选择/取消
      })
    },
    selectionChange (val) { // 单选--选择/取消
      const list = this.temporaryList
      if (val.isSelected) {
        let bool = false
        list.forEach(item => {
          if (val.id == item.id) bool = true
        })
        if (!bool) {
          list.push(val)
        }
      } else {
        let index = -1
        list.forEach((item, i) => {
          if (val.id == item.id) index = i
        })
        if (index >= 0) {
          list.splice(index, 1)
        }
      }
      // console.log('selectionChange：list', list)
      this.temporaryList = list
      if (this.temporaryList.length == 0) this.isAllSelect = true
      if (this.temporaryList.length == this.tableList.length) this.isAllSelect = false
    },
    openFW () { // 更新版本弹窗--打开
      var checkModel = true
      this.currentModel = null
      this.temporaryList.some(item => {
        if (this.currentModel == null) {
          this.currentModel = item.hardware
        } else if (this.currentModel != item.hardware) {
          this.$message({
            message: '必须选择同一种产品型号的设备',
            type: 'error'
          })
          checkModel = false
          return true
        }
      })
      if (!checkModel) return
      console.log('this.temporaryList', this.temporaryList)
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryFW()
      this.$nextTick(() => {
        this.pageshow = true
      })
      this.showUpdateVerPop = true
    },
    queryFW () { // 更新版本弹窗--初始化
      var param = {
        deviceModel: this.temporaryList[0].hardware,
        'pageNum': this.listQuery.pageInfo.pageNum,
        'pageSize': this.listQuery.pageInfo.pageSize
      }
      this.updateVerLoad = true
      pageDeviceSystemVersionList(param).then(res => {
        this.updateVerLoad = false
        if (res.resultCode == 1001) {
          this.fwList = res.resultModel.list
          this.listQuery.pageInfo.total = res.resultModel.total
        }
      })
    },
    selectFW (row) { // 弹窗--选择FW提交
      this.$confirm(i18n.t('adminView.ConfirmUpdate'), '', {//
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        console.log('更新', this.temporaryList)
        this.updateVerLoad = true
        var param = {}
        var request = null
        if (this.updateType == 1) { // 通过网络更新
          param = {
            idList: [],
            versionId: row.id
          }
          this.temporaryList.forEach(v => {
            param.idList.push({
              'deviceId': v.yhubSn,
              'mcuId': v.yhubMcu
            })
          })
          console.log('提交', param)
          request = batchUpdate
        } else { // 通过蓝牙更新
          var snStr = this.temporaryList[0].yhubSn
          this.temporaryList.forEach((v, i) => {
            if (i > 0) snStr += '\n' + v.yhubSn
          })
          param = {
            chargerSn: snStr,
            fileName: row.deviceName,
            fileVersion: row.deviceVersion,
            remark: row.remark,
            status: 0,
            updateBy: this.$store.state.userInfo.userLoginName,
            type: 2// 1 充电器、2yhub
          }
          request = add
        }
        request(param).then(res => {
          this.updateVerLoad = false
          if (res.resultCode == 1001) {
            this.isUpdate = true
            this.$message({
              message: '成功',
              type: 'success'
            })
            setTimeout(() => {
              this.showUpdateVerPop = false
              this.checkListProgress()
            }, 500)
            return
          }
          this.$message({
            type: 'error',
            message: res.resultMessage
          })
        })
      }).catch(() => { })
    },
    clearAll () { // 清空选中
      this.temporaryList = []
      this.tableList.forEach(item => {
        item.isSelected = false
      })
    },
    checkListProgress () { // 检查列表更新进度
      clearTimeout(this.checkProgresTimer)
      const list = this.tableList
      if (!list.length) return
      getFwUpdateProgress([]).then(res => { // 后台逻辑：开始更新后，10分钟未更新成功则判定失败，返回[];更新成功后10分钟内都会返回进度100，10分钟后也返回[]
        // console.log('进度列表：', res)
        if (res.resultCode != 1001 || !res.resultModel || !res.resultModel.length) return
        const progres = res.resultModel
        this.isUpdate = true
        var isFinish = false
        list.forEach((item, index) => {
          progres.forEach(element => {
            if (element.mcuId == item.yhubMcu) { // 更新中
              this.$set(this.tableList, index, {
                ...item,
                progress: element.progress,
                isUpdateCompleted: element.progress >= 100,
                isUpdate: true
              })
              if (element.progress >= 100) {
                clearTimeout(this.checkProgresTimer)
                isFinish = true
                this.$set(this.tableList, index, {
                  ...item,
                  isUpdate: false
                })
              }
            }
          })
        })
        if (isFinish) { // 更新完成，且返回有状态
          clearTimeout(this.checkProgresTimer)
          this.queryList()
          return
        }
        console.log('进度列表：', this.tableList)
        // if (this.pageLeave) return
        if (!progres.length) { // 无返回
          this.tableList.forEach(v => {
            v.isUpdate = false
          })
          return
        }
        this.checkProgresTimer = setTimeout(() => {
          this.checkListProgress()
        }, 10000)
      })
    },
    goToTestRecord (row) { // 测试日志--打开
      console.log('row', row)
      if (row) this.mcuId = row.yhubMcu
      var param = {
        mcuId: this.mcuId,
        // mcuId: '34306897183938383631354b',
        // mcuId: null,
        result: this.testRecordObj.result,
        stage: this.testRecordObj.stage
      }
      this.showTestRecordPop = this.testRecordLoad = true
      findManufactureTestLog(param).then(res => {
        console.log('132')
        this.testRecordLoad = false
        if (res.resultCode == 1001) {
          this.testRecordList = res.resultModel || []
          this.testRecordList.forEach(v => {
            if (v.createTime) v.createTimeZh = getDateAndHour(v.createTime, 'noTime')
          })
        }
      })
    },
    getDataFormat (obj1) {
      let str1 = ''
      let str2 = ''
      for (const key in obj1) {
        if (Object.hasOwnProperty.call(obj1, key)) {
          if (typeof obj1[key] == 'object') {
            str2 += '<p class="json_str">' + key + ': ' + JSON.stringify(obj1[key]) + '</p>'
          } else {
            if (key != 'name' && key != 'action') {
              str1 += '<p>' + key + ': ' + obj1[key] + '</p>'
            }
          }
        }
      }
      return str1 + str2
    },
    goToAppTestRecord (row) {
      console.log('row', row)
      this.currentSn = row.yhubSn
      this.innerVisible = true
      getProductLog(row.yhubMcu).then(res => {
        console.log(res)
        // this.testLogs = res.resultModel
        const list = res.resultModel || []
        list.sort((a, b) => b.createTime - a.createTime)
        console.log(list)
        const stepArr = []
        const arr = []
        list.forEach(item => {
          const isRep = stepArr.indexOf(item.step) >= 0
          if (!isRep) {
            const obj = JSON.parse(item.stepData)
            stepArr.push(item.step)
            arr.push({
              step: item.step,
              name: obj.name || obj.action,
              source: item.source,
              createBy: item.createBy,
              createTime: item.createTime,
              extend: this.getDataFormat(obj)
            })
          }
        })
        this.testLogs = arr
      })
    },
    changeSearch () {
      this.goToTestRecord()
    },
    closeTestRecordPop () {
      this.testRecordObj.result = this.testRecordObj.stage = ''
    },
    // 分页----start
    handleSizeChange (val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryFW()
    },
    handleCurrentChange (val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryFW()
    },
    downExcel () {
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['ProductId', 'SN', 'PC', 'MD', 'SimId', 'SimSSN', 'IMEI', 'Model', 'Lable', '']
        const filterVal = ['productId', 'yhubSn', 'yhubPc', 'yhubMd', 'simId', 'simSSN', 'netModuleImei', 'yhubMl', 'inputRange', 'labelRemark']
        const list = this.tableList
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'ProductDetail_' + this.$route.query.productId,
          autoWidth: true,
          bookType: 'xlsx'
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    },
    // 分页----end
    updateConfig () {
      var param = {
        'mcuIdList': [],
        'productConfigId': this.$route.query.productId
      }
      this.temporaryList.forEach(v => {
        param.mcuIdList.push(v.yhubMcu)
      })
      updateDeviceConfig(param).then(res => {
        if (res.resultCode == 1001) {
          updateDeviceWarningSetting(param).then(res => {
            if (res.resultCode == 1001) {
              this.$message({
                message: '成功',
                type: 'success'
              })
              this.allSelect('cancelSelect')// 取消选中
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.json_str {
  background-color: #ddd;
  height: 30px;
  overflow: hidden;
  border-bottom: 5px solid #fff;
  &:hover {
    height: auto;
  }
}
#productDetail {
  background: #fff;
  padding: 20px;
  pre {
    word-break: break-word;
    white-space: normal;
    word-wrap: break-word;
    display: inline-block;
    text-indent: 20px;
    margin-bottom: 0;
  }
  .el-step.is-vertical .el-step__title {
    margin-bottom: 15px;
  }
  .el-step__description.is-process {
    padding-bottom: 15px;
  }
  .box {
    display: flex;
    &:nth-of-type(1) {
      border-bottom: 1px solid #dfe4ed;
      margin-bottom: 22px;
    }
    .el-form-item {
      width: 33%;
    }
  }
  .testRecordPop .el-dialog {
    overflow: auto;
    max-height: 85%;
    .testRecordTable {
      max-height: calc(80vh - 90px);
      overflow: auto;
    }
  }
}

.item_p {
  margin: 20px 0;
  &:first-of-type {
    margin-top: 0;
  }
}
</style>
